import React, { Component } from "react";
import { connect } from "react-redux";
import { getMarkIrrPopupUrl } from "./postInfoUtils";
import moment from "moment-timezone";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import Dropdown from "semantic-ui-react/dist/es/modules/Dropdown";
import PostInfoModal from "../PostInfoModal/PostInfoModal";
import PostEmailModal from "../PostEmailModal/PostEmailModal";
import IrrPostModal from "../IrrPostModal/IrrPostModal";
import TagClientModal from "../TagClientModal/TagClientModal";
import AddToCollectionModal from "../AddToCollectionModal/AddToCollectionModal";
import UpdateAssignedStatus from "../UpdateAssignedStatus/UpdateAssignedStatus";
import { toast } from "react-toastify";
import "./PostHeader.scss";
import { fetchPostInfo, emailPost, getClients, tagClient, getTeamsIBelongTo, updateListenPost } from "../../../../actions/rawDataAction";
import { fetchSMRPageList } from "../../../../actions/socialResponseActions";
import { setSentiment, fetchBlockSourceMessage, removeIrrPost } from "../../../../actions/dashboardAction";
import { markPostSafety } from "../../../../actions/dashboardAction";
import { bulkContentSafetyUpdate } from "../../../../actions/dashboardAction";
import { fetchCollectionsList, addToCollection, setCoverPhoto, deletePostFromCollection, updateAssignedStatus } from "../../../../actions/collectionsActions";
import { ReactComponent as CollectionIcon } from "../../../../assets/svg/collection.svg";
import { ReactComponent as PositiveSentiment } from "../../../../assets/svg/positive-sentiment.svg";
//import PositiveSentiment from "../../../../assets/svg/positive-sentiment.svg";
import { ReactComponent as NegativeSentiment } from "../../../../assets/svg/negative-sentiment.svg";
//import NegativeSentiment from "../../../../assets/svg/negative-sentiment.svg";
import { ReactComponent as NeutralSentiment } from "../../../../assets/svg/neutral-sentiment.svg";
// import NeutralSentiment from "../../../../assets/svg/neutral-sentiment.svg";
import { ReactComponent as Campaign } from "../../../../assets/campaigning-svgrepo-com.svg";
import { ReactComponent as PostInfo } from "../../../../assets/svg/info.svg";
import { ReactComponent as PostMenu } from "../../../../assets/svg/menu.svg";
import { ReactComponent as Email } from "../../../../assets/svg/email.svg";
import { ReactComponent as MarkAsIrrelevant } from "../../../../assets/svg/mark-as-Irrelevant.svg";
import { ReactComponent as Shield } from "../../../../assets/svg/shield1.svg";
import { ReactComponent as TagToClient } from "../../../../assets/svg/tag-to-client.svg";
import { ReactComponent as AssignedStatusIcon } from "../../../../assets/svg/update-sync-status.svg";
import { ReactComponent as SetCoverPhoto } from "../../../../assets/svg/set-cover-picture.svg";
import { ReactComponent as TwitterVerificationIcon } from "../../../../assets/svg/twitter-verification-icon.svg";
import { ReactComponent as FacebookVerificationIcon } from "../../../../assets/svg/facebook-verification-icon.svg";
import { ReactComponent as InfoIcon } from "../../../../assets/svg/info-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/svg/delete.svg";
import { ReactComponent as SfSyncIcon } from "../../../../assets/svg/sfsync.svg";
import SyncToSMRModal from "../SyncToSMRModal/SyncToSMRModal";
import { ReactComponent as RadarrIcon } from "../../../../assets/svg/radarr-icon.svg";
import { ReactComponent as UserProfile } from "../../../../assets/svg/profile-user.svg";
// import { fetchCampaigns } from "../../../MainContent/SMP/Settings/Campaign/CampaignActions";

import Icon from "semantic-ui-react/dist/es/elements/Icon";
import { isMobile } from "react-device-detect";

import blankUser from "./icons/user_blank.png";
import { reloadConversationPage } from "../../../../actions/keywordSyncedPostsAction";

const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

class PostHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            postInfoModalOpen: false,
            postEmailModalOpen: false,
            markIrrModalOpen: false,
            tagClientModalOpen: false,
            addToCollectionModalOpen: false,
            assignedStatusModalOpen: false,
            assignedStatusData: null,
            emailSelectedPost: null,
            blockMessage: null,
            irrPostId: "",
            tagClientSelectedPost: null,
            collSelectedPostId: null,
            enabledSync: false,
            smrPages: [],
            syncPostLoading: false,
            // campaigns: [],
            campaignName: "",
        };

        this.irrUrl = "";

        this.isCollection = this.props.dashboardPageType === "collection";
        this.isResearch = this.props.dashboardPageType === "research";
        this.isSMRKeywordSync = this.props.dashboardPageType === "smrKeywordSync";
    }

    // fetchCampaign = async () => {
    //     const campaignsData = await fetchCampaigns();
    //     this.setState({ campaigns: campaignsData });
    // };

    componentDidMount() {
        // this.props.fetchSMRPageList();
        if (this.props.data.syncToSmr == 1) {
            this.setState({ enabledSync: true });
        }
        // this.fetchCampaign();
    }
    findCampaignName = (campaignId) => {
        const campaign = this.props.campaigns?.find((campaign) => campaign.id === campaignId);
        return campaign ? campaign.campaign_name : "";
    };

    // componentDidUpdate(prevProps) {
    //     if (prevProps.smrPagesList != this.props.smrPagesList) {
    //         let pages = Object.values(this.props.smrPagesList);
    //         this.setState({ smrPages: pages });
    //     }
    // }

    showPostInfo = () => {
        this.postInfoModalShowSet(true);
        this.props.fetchPostInfo(this.props.data.postId);
    };

    postInfoModalShowSet = (postInfoModalOpen) => {
        this.setState({ postInfoModalOpen });
    };

    postEmailModalShowSet = (show, data) => {
        this.setState({
            postEmailModalOpen: show,
            emailSelectedPost: data,
        });
    };

    syncedToSmr = (pageId) => {
        let params = {};
        let post = [];
        let es_id = {};
        params["page_id"] = pageId;
        es_id["es_id"] = this.props.data.postId.split(":")[1];
        es_id["index"] = this.props.data.postId.split(":")[0];

        post.push(es_id);
        params["posts"] = post;
        this.setState({
            syncPostLoading: true,
        });
        this.props
            .updateListenPost(params)
            .then((res) => {
                if (
                    res?.value?.data?.sync_results[0]?.synced_to_smr === 1 ||
                    res?.value?.data?.sync_results[0]?.smr_synced_company_ids?.includes(this.props.company.company_lite_company_id)
                ) {
                    const successMsg = this.isSMRKeywordSync ? "Converted to ticket successfully." : "Synced to SMR successfully.";
                    toast.success(successMsg);
                    this.setState({ enabledSync: true, syncToSMRModal: false, syncPostLoading: false });
                } else {
                    this.setState({
                        syncPostLoading: false,
                    });
                    const errMsg = this.isSMRKeywordSync ? "Ticket conversion failed. Please try again later." : "Synced to SMR for this post not supported.";
                    toast.error(errMsg);
                }
            })
            .finally(() => {
                console.log("check");
                if (this.isSMRKeywordSync) {
                    this.props.reloadConversationPage();
                }
            });
    };

    emailPost = (toAddr, subject, content, logo) => {
        this.postEmailModalShowSet(false);
        this.props.emailPost(toAddr, subject, content, logo);
    };

    renderSentiment = () => {
        const getSentimentIcon = () => {
            if (this.props.data.sentimentType.includes("POSITIVE")) return <PositiveSentiment className="sentiment-icon" />;
            else if (this.props.data.sentimentType.includes("NEGATIVE")) return <NegativeSentiment className="sentiment-icon" />;
            else return <NeutralSentiment className="sentiment-icon" />;
        };

        return (
            <Dropdown
                icon={null}
                // disabled={this.props.isPublic}
                text=""
                trigger={
                    <Popup
                        className="skiptranslate"
                        trigger={getSentimentIcon()}
                        content={this.props.data.sentimentType}
                        inverted
                        size="mini"
                        style={{ zIndex: 9999999 }}
                    />
                }
                direction="left">
                <Dropdown.Menu>{!this.props.isPublic && this.renderSentimentTooltip()}</Dropdown.Menu>
            </Dropdown>
        );
    };

    renderSentimentTooltip = () => {
        let args = {
            postData: this.props.postData,
            company: this.props.company,
            postIndex: this.props.postIndex,
        };
        return (
            <div className="tooltip-contents">
                <PositiveSentiment
                    onClick={() => {
                        args.sentiment = "POSITIVE";
                        this.setSentiment(args);
                    }}
                />
                <NeutralSentiment
                    onClick={() => {
                        args.sentiment = "NEUTRAL";
                        this.setSentiment(args);
                    }}
                />
                <NegativeSentiment
                    onClick={() => {
                        args.sentiment = "NEGATIVE";
                        this.setSentiment(args);
                    }}
                />
            </div>
        );
    };

    setSentiment = (args) => {
        if (this.isResearch) {
            toast.error("This functionality is not available on Search page.");
            return;
        }
        this.props.setSentiment(args).then((data) => {
            if (data.value) this.props.updatePostAfterSentimentUpdate(data.value);
        });
    };

    markIrrModalShowSet = (show, data) => {
        if (data) {
            if (data._source.platforms.youtube) {
                this.irrUrl = `https://www.youtube.com/${data._source.handlers[0]}`;
            } else {
                this.irrUrl = getMarkIrrPopupUrl(data);
            }
            this.setState({
                blockMessage: {
                    url: data._source.post.url,
                    username: data._source.post_author.username,
                    platform: data._source.platforms[0].short_name,
                    handler: data._source.handlers[0].value,
                    _id: data._id,
                },
                irrPostId: data._index + ":" + data._id,
                markIrrModalOpen: show,
            });
        } else {
            this.setState({
                markIrrModalOpen: show,
            });
        }
    };

    removeIrrPost = ({ type, val }) => {
        this.props.removeIrrPost({ type, val, postId: this.state.irrPostId, company: this.props.company }).then((data) => {
            if (data.value) this.props.updatePostAfterMarkAsIrr(data.value);
        });
    };

    handleMarkSafetyClick = (content) => {
        const newPrediction = ["SFW", "SFW_MANUAL"].includes(content) ? "NSFW" : "SFW";
        const { data } = this.props;
        markPostSafety(data.postId, newPrediction);
    };

    tagClientModalShowSet = (show, data) => {
        if (data && this.props.data.platformName.toLowerCase() === "youtube") {
            const diffDays = moment()
                .tz(this.props.company.user_timezone_name)
                .endOf("day")
                .diff(moment(data._source.post.published_date).tz(this.props.company.user_timezone_name), "days");
            // const diffDays = Math.round(Math.abs((new Date().setHours(0, 0, 0, 0) - new Date(data._source.created_date).setHours(0, 0, 0, 0)) / oneDay));
            if (diffDays >= 30) {
                toast.error("Tagging of YouTube post beyond 30 days not allowed.");
                return;
            }
        }
        this.setState({
            tagClientSelectedPost: data ? JSON.parse(JSON.stringify(data)) : data,
            tagClientModalOpen: show,
        });
    };

    tagClient = (id, cmpny_list) => {
        this.props.tagClient(id, cmpny_list).then(() => {
            let data = JSON.parse(JSON.stringify(this.props.postData));
            data._source.company_ids = [...data._source.company_ids, ...cmpny_list];
            this.props.updatePostAfterTagToClient({ data, postIndex: this.props.postIndex });
        });
    };

    addToCollectionModalSet = (show, data) => {
        if (this.isResearch) {
            toast.error("This functionality is not available on Search page.");
            return;
        }
        if (show === true) this.props.fetchCollectionsList();
        this.setState({
            addToCollectionModalOpen: show,
            collSelectedPostId: data ? data._index + ":" + data._id : null,
        });
    };

    addToCollection = (id, coll) => {
        this.setState({
            addToCollectionModalOpen: false,
        });
        this.props.addToCollection(id, coll);
    };

    assignedStatusModalShowSet = (show) => {
        this.setState({
            assignedStatusModalOpen: show,
            assignedStatusData: { data: this.props.postData, sync_status: this.props.sync_status },
        });
    };

    handleImageError = () => {
        this.authorImage.src = blankUser;
    };

    setCoverPhoto = () => {
        let data = this.props.postData._source.post.media[0].type === "IMAGE" ? this.props.postData._source.post.media[0] : null;
        this.props.setCoverPhoto({ id: this.props.currentCollection.id, data });
    };

    deletePostFromCollection = () => {
        this.props
            .deletePostFromCollection({
                es_index: this.props.postData._index,
                es_id: this.props.postData._id,
                collection_id: this.props.currentCollection.id,
            })
            .then((data) => {
                if (data.value) this.props.updatePostAfterDeleteFromCollection(this.props.postData._id);
            });
    };
    handleSyncToSMRModal = (platformName) => {
        this.setState({ syncToSMRModal: platformName === "X" ? "twitter" : platformName });
    };
    getHandleName = () => {
        // return this.props.data?.platformName === "Instagram" ? this.props.smpPageList[this.props.data?.pageId]?.page_username : this.props.data.postAuthor;
        if (this.props.data?.platformName === "Instagram") {
            return this.props.smpPageList[this.props.data?.pageId]?.page_username
                ? this.props.smpPageList[this.props.data?.pageId]?.page_username
                : this.props.data?.postAuthor;
        }
        return this.props.data.postAuthor;
    };
    render() {
        const campaignId = this.props.postData?._source.post?.campaign_id;
        const campaignName = this.findCampaignName(campaignId);
        const popupContent = campaignId ? `Campaign Name: ${campaignName || "N/A"}` : "Campaign Name: N/A";

        return (
            <div className={`post-header skiptranslate ${this.props.listView ? "post-header-listview" : ""} ${isMobile && "mobile__version__query"}`}>
                <div className="post-header-info">
                    <div className="post-header-info-left">
                        {this.props.data.postAuthorImg ? (
                            <div className="post-author-image">
                                <img
                                    crossOrigin="anonymous"
                                    src={this.props.data.postAuthorImg}
                                    alt=""
                                    onError={() => this.handleImageError()}
                                    ref={(el) => {
                                        this.authorImage = el;
                                    }}
                                />
                            </div>
                        ) : (
                            <UserProfile />
                        )}
                        <div className="post-details">
                            <div className="post-details-top">
                                <Popup
                                    trigger={<span className="post-author-name skiptranslate">{this.getHandleName()}</span>}
                                    content={this.getHandleName()}
                                    inverted
                                    className="skiptranslate"
                                    size="mini"
                                    position="top center"
                                    style={{ zIndex: 2000000 }}
                                />
                                {this.props.data.postAuthor && <div data-html2canvas-ignore="true" className="post-details-separator"></div>}
                                <Popup
                                    trigger={
                                        <span data-html2canvas-ignore="true" className="post-publish-time skiptranslate">
                                            {this.props.data.postTime[0]}
                                        </span>
                                    }
                                    content={this.props.data.postTime[1]}
                                    inverted
                                    className="skiptranslate"
                                    size="mini"
                                    position="top center"
                                    data-html2canvas-ignore="true"
                                />
                                {!this.props.isPublic && (
                                    <Popup
                                        trigger={<PostInfo data-html2canvas-ignore="true" className="post-info" onClick={this.showPostInfo} />}
                                        content="Post Information"
                                        inverted
                                        className="skiptranslate"
                                        size="mini"
                                        position="right center"
                                        data-html2canvas-ignore="true"
                                    />
                                )}
                                {!this.props.isPublic && this.props.data.postSubType === "ads" && (
                                    <Popup
                                        trigger={
                                            <div className="info-icon" data-html2canvas-ignore="true">
                                                <InfoIcon />
                                            </div>
                                        }
                                        content="The images might differ from the original Promoted Post but it will be from the same set of pictures user provided."
                                        inverted
                                        className="skiptranslate"
                                        size="mini"
                                        position="right center"
                                        data-html2canvas-ignore="true"
                                    />
                                )}

                                {!this.props.isPublic && this.props.data.postedOnSMP == 1 && (
                                    <Popup
                                        trigger={
                                            <div>
                                                {" "}
                                                <RadarrIcon />{" "}
                                            </div>
                                        }
                                        content="Published from Radarr"
                                        inverted
                                        size="mini"
                                        position="bottom center"
                                        className="post-header-popup skiptranslate"
                                    />
                                )}
                            </div>
                            <div className="post-details-bottom skiptranslate">
                                {this.props.data.postType === "online" && (
                                    <Popup
                                        trigger={<div className="online-dot" />}
                                        content="online"
                                        inverted
                                        size="mini"
                                        position="bottom center"
                                        className="post-header-popup skiptranslate"
                                    />
                                )}
                                <div className="post-platform-icon">
                                    <Popup
                                        trigger={
                                            <img
                                                alt={this.props.data.platformName}
                                                src={`${process.env.PUBLIC_URL}/icons/platform_icons/${
                                                    this.props.data.platformName == "Google Business"
                                                        ? "gmb"
                                                        : this.props.data.platformName == "China-Videos"
                                                        ? "douyin"
                                                        : this.props.data.platformName === "Google Play Store"
                                                        ? "playstore"
                                                        : this.props.data.platformName === "App Store"
                                                        ? "appstore"
                                                        : this.props.data.platformName.toLowerCase()
                                                }_icon.png`}
                                            />
                                        }
                                        content={
                                            this.props.data.plaformNameTitle === "China-Videos"
                                                ? "Douyin"
                                                : this.props.data.plaformNameTitle === "China-WeChat"
                                                ? "WeChat"
                                                : this.props.data.plaformNameTitle === "China-Weibo"
                                                ? "Weibo"
                                                : this.props.data.plaformNameTitle === "Twitter"
                                                ? "X"
                                                : this.props.data.plaformNameTitle
                                        }
                                        //content={this.props.data.plaformNameTitle}

                                        inverted
                                        size="mini"
                                        className="skiptranslate"
                                        position="bottom center"
                                    />
                                </div>
                                {this.props.data.postAuthorIsVerified ? (
                                    <span className="verification-icon" title="Verified Profile">
                                        {this.props.data.platformName.toLowerCase() === "twitter" ? <TwitterVerificationIcon /> : <FacebookVerificationIcon />}
                                    </span>
                                ) : null}
                                {this.props.data.postSubType === "ads" && <span className="promoted-post">Promoted</span>}
                                {this.props.data.followersCount ? (
                                    <span className="post-author-followers-count">
                                        {"| " +
                                            this.props.data.followersCount +
                                            (this.props.data.platformName.toLowerCase() === "youtube" ? " subscribers" : " followers")}
                                    </span>
                                ) : null}
                                {this.props.dashboardPageType === "SMP" ? (
                                    <>
                                        {campaignId ? <span className="post-author-followers-count1 ">{"| "}</span> : null}
                                        {campaignId ? (
                                            <Popup
                                                trigger={<Campaign className="campaign1" />}
                                                content={popupContent}
                                                inverted
                                                className="skiptranslate"
                                                size="mini"
                                                position="right center"
                                                data-html2canvas-ignore="true"
                                            />
                                        ) : null}
                                    </>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    {!this.props.engagement ? (
                        <div className="post-header-info-right skiptranslate">
                            {!this.props.isPublic && !this.isSMRKeywordSync && (
                                <Popup
                                    trigger={
                                        <CollectionIcon
                                            data-html2canvas-ignore="true"
                                            className={`add-to-collection-icon ${this.isResearch ? "add-to-collection-icon-research" : ""}`}
                                            onClick={() => this.addToCollectionModalSet(true, this.props.postData)}
                                        />
                                    }
                                    content={this.isCollection ? "Copy to Collection" : "Add to Collection"}
                                    inverted
                                    className="skiptranslate"
                                    position="left center"
                                    size="mini"
                                />
                            )}
                            {this.isSMRKeywordSync && (
                                <Popup
                                    className="skiptranslate"
                                    trigger={
                                        <SfSyncIcon className="smr-keyword-sync" onClick={() => this.handleSyncToSMRModal(this.props.data.platformName)} />
                                    }
                                    content="Convert to ticket"
                                    inverted
                                    size="mini"
                                    style={{ zIndex: 9999999 }}
                                />
                            )}
                            {this.renderSentiment()}
                            {!this.props.isPublic && !this.isSMRKeywordSync && (
                                <Dropdown
                                    data-html2canvas-ignore="true"
                                    trigger={<PostMenu className="post_menu" />}
                                    icon={null}
                                    direction="left"
                                    className="post-menu skiptranslate">
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => this.postEmailModalShowSet(true, this.props.postData)}>
                                            <span>
                                                <Email />
                                            </span>
                                            <span>Email This Post</span>
                                        </Dropdown.Item>
                                        {!this.isCollection && !this.isResearch && this.props.dashboardPageType != "SMP" && (
                                            <Dropdown.Item onClick={() => this.markIrrModalShowSet(true, this.props.postData)}>
                                                <span>
                                                    <MarkAsIrrelevant />
                                                </span>
                                                <span>Mark as Irrelevant</span>
                                            </Dropdown.Item>
                                        )}
                                        {["X", "Facebook Comments", "Facebook", "LinkedIn"].includes(this.props.data.platformName) &&
                                            this.props.packageObj?.features?.smr_module_access.quota == 1 && (
                                                <Dropdown.Item
                                                    disabled={this.state.enabledSync}
                                                    onClick={!this.state.enabledSync ? () => this.handleSyncToSMRModal(this.props.data.platformName) : ""}>
                                                    <span>
                                                        <SfSyncIcon /> {this.state.enabledSync ? "Synced to SMR" : "Sync to SMR"}
                                                    </span>
                                                </Dropdown.Item>
                                            )}
                                        {!this.isCollection && this.props.company.company_lite_company_id === 10202 && this.props.dashboardPageType != "SMP" && (
                                            <Dropdown.Item onClick={() => this.tagClientModalShowSet(true, this.props.postData)}>
                                                <span>
                                                    <TagToClient />
                                                </span>
                                                <span>Tag to Client</span>
                                            </Dropdown.Item>
                                        )}

                                        {["IMAGE", "VIDEO"].includes(this.props.data.postMediaType) ? (
                                            <Dropdown.Item onClick={() => this.handleMarkSafetyClick(this.props.data.postContentSafety)}>
                                                <span>
                                                    <Shield />
                                                </span>
                                                <span>
                                                    {" "}
                                                    {this.props.data.postContentSafety === "SFW" || this.props.data.postContentSafety === "SFW_MANUAL"
                                                        ? "Mark as NSFW"
                                                        : "Mark as SFW"}
                                                </span>
                                            </Dropdown.Item>
                                        ) : null}

                                        {this.isCollection && this.props.deletePostFromCollection && this.props.dashboardPageType != "SMP" && (
                                            <Dropdown.Item onClick={this.deletePostFromCollection}>
                                                <span>
                                                    <MarkAsIrrelevant />
                                                </span>
                                                <span>Delete From Collection</span>
                                            </Dropdown.Item>
                                        )}
                                        {this.isCollection && this.props.fetchCollectionData && this.props.dashboardPageType != "SMP" && (
                                            <Dropdown.Item onClick={() => this.assignedStatusModalShowSet(true)}>
                                                <span>
                                                    <AssignedStatusIcon />
                                                </span>
                                                <span>Change Review Status</span>
                                            </Dropdown.Item>
                                        )}
                                        {this.isCollection &&
                                            this.props.data.postImg &&
                                            this.props.data.postMediaType === "IMAGE" &&
                                            this.props.setCoverPhoto &&
                                            this.props.dashboardPageType != "SMP" && (
                                                <Dropdown.Item onClick={this.setCoverPhoto}>
                                                    <span>
                                                        <SetCoverPhoto /> Set Cover Picture
                                                    </span>
                                                </Dropdown.Item>
                                            )}

                                        {this.props.dashboardPageType == "SMP" && this.props.data.postedOnSMP == 1 && (
                                            <Dropdown.Item
                                                disabled={this.props.data.platformName == "Instagram"}
                                                onClick={() => this.props.deletePublishedPost(this.props.postData)}>
                                                <span>
                                                    <DeleteIcon /> Delete
                                                </span>
                                            </Dropdown.Item>
                                        )}
                                    </Dropdown.Menu>
                                </Dropdown>
                            )}
                        </div>
                    ) : null}
                </div>
                <div className="post-header-boundary skiptranslate">
                    {!this.props.engagement && <span className="post-index">{"#" + (this.props.index + 1)}</span>}
                    <div className="post-header-separator" style={{ background: this.props.data.postColor }}></div>
                </div>
                <PostInfoModal
                    data={this.props.postInfo}
                    apiStatus={this.props.postInfoStatus}
                    open={this.state.postInfoModalOpen}
                    hideModal={() => this.postInfoModalShowSet(false)}
                    platformName={this.props.data.platformName}
                    isTrial={this.props.isTrial}
                />
                <PostEmailModal
                    open={this.state.postEmailModalOpen}
                    hideModal={() => this.postEmailModalShowSet(false)}
                    data={this.state.emailSelectedPost}
                    emailPost={this.emailPost}
                    company={this.props.company}
                />
                <IrrPostModal
                    blockMessage={this.state.blockMessage}
                    open={this.state.markIrrModalOpen}
                    blockUrl={this.irrUrl}
                    hideModal={() => this.markIrrModalShowSet(false)}
                    removeIrrPost={(type, val) => this.removeIrrPost({ type, val })}
                />
                <TagClientModal
                    open={this.state.tagClientModalOpen}
                    active_company_list={this.props.active_company_list}
                    hideModal={() => this.tagClientModalShowSet(false)}
                    getClients={() => this.props.getClients()}
                    data={this.state.tagClientSelectedPost}
                    tagClient={this.tagClient}
                />
                <AddToCollectionModal
                    open={this.state.addToCollectionModalOpen}
                    hideModal={() => this.addToCollectionModalSet(false)}
                    collections={this.props.collectionsList}
                    collectionsFetching={this.props.collectionsListFetching}
                    addToCollection={(coll) => this.addToCollection(this.state.collSelectedPostId, coll)}
                    teamOptions={this.props.teamsIBelongToOptions}
                    getTeamOptions={() => this.props.getTeamsIBelongTo()}
                />
                <UpdateAssignedStatus
                    open={this.state.assignedStatusModalOpen}
                    hideModal={() => this.setState({ assignedStatusModalOpen: false, assignedStatusData: null })}
                    updateAssignedStatus={(data) => {
                        this.props.updateAssignedStatus({ collection: this.props.currentCollection, ...data }).then(() => {
                            setTimeout(() => this.props.fetchCollectionData(), 1000);
                        });
                    }}
                    assignedStatus={this.state.assignedStatusData}
                />

                {this.state.syncToSMRModal ? (
                    <SyncToSMRModal
                        open={this.state.syncToSMRModal}
                        hideModal={() => this.setState({ syncToSMRModal: false })}
                        syncedToSmr={this.syncedToSmr}
                        smrPages={this.props.smrPages}
                        syncPostLoading={this.state?.syncPostLoading}
                        // collections={this.props.collectionsList}
                        // collectionsFetching={this.props.collectionsListFetching}
                        // addToCollection={(coll) => this.addToCollection(this.state.collSelectedPostId, coll)}
                        // teamOptions={this.props.teamsIBelongToOptions}
                        // getTeamOptions={() => this.props.getTeamsIBelongTo()}
                    />
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    postInfo: state.rawDataReducer.postInfo,
    postInfoStatus: state.rawDataReducer.postInfoStatus,
    isTrial: (state.globalReducer.company && state.globalReducer.company.is_trial) || 0,
    active_company_list: state.rawDataReducer.active_company_list,
    collectionsList: state.collectionsReducer.collectionsList,
    collectionsListFetching: state.collectionsReducer.collectionsListFetching,
    teamsIBelongToOptions: state.rawDataReducer.teamsIBelongToOptions,
    company: state.globalReducer.company,
    smrPagesList: state.socialResponseReducer.smrPagesList,
    currentCollection: state.collectionsReducer.currentCollection,
    packageObj: state.globalReducer.packageObj,
    smpPageList: state.SMPReducer.smpPageList,
});

const mapDispatchToProps = (dispatch) => ({
    fetchPostInfo: (id) => dispatch(fetchPostInfo(id)),
    emailPost: (toAddr, subject, content, logo) => dispatch(emailPost(toAddr, subject, content, logo)),
    setSentiment: (args) => dispatch(setSentiment(args)),
    fetchBlockSourceMessage: (obj) => dispatch(fetchBlockSourceMessage(obj)),
    removeIrrPost: (obj) => dispatch(removeIrrPost(obj)),
    markPostSafety: (obj) => dispatch(markPostSafety(obj)),
    bulkContentSafetyUpdate: (obj) => dispatch(bulkContentSafetyUpdate(obj)),
    setCoverPhoto: (obj) => dispatch(setCoverPhoto(obj)),
    getClients: () => dispatch(getClients()),
    tagClient: (id, cmpny_list) => dispatch(tagClient(id, cmpny_list)),
    getTeamsIBelongTo: () => dispatch(getTeamsIBelongTo()),
    fetchCollectionsList: () => dispatch(fetchCollectionsList()),
    addToCollection: (id, coll) => dispatch(addToCollection(id, coll)),
    deletePostFromCollection: (arg) => dispatch(deletePostFromCollection(arg)),
    updateAssignedStatus: (arg) => dispatch(updateAssignedStatus(arg)),
    updateListenPost: (arg) => dispatch(updateListenPost(arg)),
    fetchSMRPageList: () => dispatch(fetchSMRPageList()),
    reloadConversationPage: () => dispatch(reloadConversationPage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PostHeader);
